<h3
    (click)="onToggleMenu()"
    (keyup.enter)="onToggleMenu()"
    role="button"
    tabindex="0"
    class="fs-12 text-white text-uppercase"
    [ngClass]="{ expanded: expanded }"
>
    <ng-content></ng-content>
</h3>
